/**
 * The 844 list's `?acknowledgement=` filter: what the URL may hold and what it
 * asks the list query for. Kept out of the component file so Fast Refresh can
 * preserve component state.
 */

import {
  EDI844AcknowledgementStatusSchema,
  type EDI844AcknowledgementStatus,
} from '@erp/rpc';

/** A `?acknowledgement=` search value, or 'all' when absent or unknown. */
export function parseAcknowledgementFilter(
  value: unknown,
): EDI844AcknowledgementStatus | 'all' {
  const parsed = EDI844AcknowledgementStatusSchema.safeParse(value);
  return parsed.success ? parsed.data : 'all';
}

/** The list query's filter for a `?acknowledgement=` choice. */
export function acknowledgementQueryParam(
  filter: EDI844AcknowledgementStatus | 'all',
): EDI844AcknowledgementStatus[] | undefined {
  return filter === 'all' ? undefined : [filter];
}
